const React = require("react");
const delay = require("mn-utils/delay");
const {openPopupWindow, openV1PopupInfo} = require("../../../../../../../emitters/popup");
const Popup = require("../../../../../../dumb/Popup/C");
const WrapperWithLoading = require("../../../../../../dumb/WrapperWithLoading");
const {apiAdminCustomerRefundDecline} = require("../../../../../../../api/admin/refunds");

module.exports = (refund, reload) => openPopupWindow((setPopupState, popup) => {
  const {close} = popup;
  popup.state = {
    loading: false,
  };

  return (stateOfPopup) => {
    return (
      <Popup caption={(
        <div className="layoutRow fhaS fvaC w">
          <div>Decline Customer Refund</div>
        </div>
      )}
       text="Decline"
       onCancel={close}
       onSave={() => {
         setPopupState({
           loading: true,
         });

         apiAdminCustomerRefundDecline({issue_id: refund.id}).finally((error) => {
           setPopupState({
             loading: false,
           });

           if (error) {
             return;
           }
           reload && reload()
           close();
           delay(openV1PopupInfo(['Success', `Refund ${refund.id} has been declined`]), 500);
         });
       }}
      >
        <WrapperWithLoading loading={stateOfPopup.loading}>
          <div className="mt20">Do you want to decline #{refund.id} refund?</div>
        </WrapperWithLoading>
      </Popup>
    );
  };
});
